import { render } from "./AccountSet.vue?vue&type=template&id=54a1cc4a&scoped=true"
import script from "./AccountSet.vue?vue&type=script&lang=js"
export * from "./AccountSet.vue?vue&type=script&lang=js"

import "./AccountSet.vue?vue&type=style&index=0&id=54a1cc4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a1cc4a"]])

export default __exports__